module.exports = __webpack_public_path__ + "static/img_9515-adf10e9a361664d832bbdffb8db6d465.webp";